import * as React from 'react';
import SelectUnstyled, { selectUnstyledClasses } from '@mui/base/SelectUnstyled';
import OptionUnstyled, { optionUnstyledClasses } from '@mui/base/OptionUnstyled';
import PopperUnstyled from '@mui/base/PopperUnstyled';
import { styled } from '@mui/system';
import ArrowDropUpIcon from '../styles/images/caret-up-solid.svg';
import ArrowDropDownIcon from '../styles/images/caret-down-solid.svg';
import ArrowDropDownRedIcon from '../styles/images/caret-down-solid-red.svg';
import ArrowDropUpRedIcon from '../styles/images/caret-up-solid-red.svg';

const StyledButton = styled('button')`
  display: flex;
  justify-content: space-between;
  box-sizing: border-box;
  background: transparent;
  text-align: left;
  border: none;
  color: var(--color, #3A415A);
  font-size: 19px;
  margin: 0;
  padding: 0;
  position: relative;
  overflow: visible;
  z-index: 100;

  &:hover {
    color: #C91113;

    &::after {
      content: url(${ArrowDropDownRedIcon});
      font-size: 21px;
      line-height: 1;
      margin-left: 8px;
      width: 12px;
    }

    &.${selectUnstyledClasses.expanded} {
      &::after {
        content: url(${ArrowDropUpRedIcon});
        font-size: 21px;
        line-height: 1;
        margin-left: 8px;
        width: 12px;
      }
    }
  }
  
  &.${selectUnstyledClasses.focusVisible} {
    outline: none;
    color: #C91113;
  }

  &.${selectUnstyledClasses.expanded} {
    &::after {
      content: url(${ArrowDropUpIcon});
      font-size: 21px;
      line-height: 1;
      margin-left: 8px;
      width: 12px;
    }
  }

  &.${selectUnstyledClasses.active} {
    color: #C91113;
  }

  &.${optionUnstyledClasses.selected} {
    color: #C91113;
  }

  &::after {
    content: url(${ArrowDropDownIcon});
    font-size: 21px;
    line-height: 1;
    margin-left: 8px;
    width: 12px;
  }
`;

const StyledListbox = styled('ul')`
  font-size: 16px;
  box-sizing: border-box;
  padding: 0;
  margin: 0;
  background-color: #fff;
  border-top: 5px solid #C91113;
  color: #3A415A;
  border-radius: 11px;
  overflow: auto;
  max-height: 350px;
`;

const StyledOption = styled(OptionUnstyled)`
  list-style: none;
  padding: 12px 11px;
  margin: 0;
  border-radius: 0;
  border-bottom: 1px solid #E2E2E2;
  cursor: default;
  color: #3A415A;
  background-color: #fff;
  
  &:hover {
    background-color: #F5F6FA;
    color: #C91113;
  }

  &:last-of-type {
    border-bottom: none;
    border-radius: 0 0 11px 11px;
  }

  &.${optionUnstyledClasses.disabled} {
    color: #888;
  }

  &.${optionUnstyledClasses.selected} {
    color: #C91113;
  }

  &.${optionUnstyledClasses.highlighted} {
    color: #C91113;
  }
`;

const StyledPopper = styled(PopperUnstyled)`
  z-index: 102;
  top: 11px;
  border-radius: 11px;
  min-width: 200px;
  width: 100%;
  box-shadow: rgb(0 0 0 / 20%) 0 3px 3px -2px, rgb(0 0 0 / 14%) 0 3px 4px 0px, rgb(0 0 0 / 12%) 0 1px 8px 0px;
  outline: none !important;
`;

const CustomSelectElement = React.forwardRef(function CustomSelect(props, ref) {

  const components = {
    Root: StyledButton,
    Listbox: StyledListbox,
    Popper: StyledPopper,
    ...props.components,
  };

  const componentsProps = {
    popper: {
      placement: props.placement,
    },
    root: {
      style: {
        [!props.value]: {
          color: 'red'
        }
      }
    }
  };

  return <SelectUnstyled {...props}
                         ref={ref}
                         components={components}
                         componentsProps={componentsProps}
                         onChange={(value) => {
                           props.onChangeFn(value);
                         }}
                         value={props.value}
                         defaultValue={false} />;
});

export default function CustomSelect(props) {
  return (
    <CustomSelectElement onChangeFn={props.onChangeFn} value={props.value} placement={props.placement} {...props}>
      {props.label &&
        <StyledOption id={'placeholder'} key={'placeholder'} value={false}>{props.label}</StyledOption>
      }
      {props.options.map((option) => (
        <StyledOption
          key={option.Name ? option.Name : option}
          value={option.Name ? option.Name : option}>
          {option.Label || (option.Label === "") || (option.Label === null) ? option.Label : option }
        </StyledOption>
      ))}
    </CustomSelectElement>
  );
}
